<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-7 col-12 py-2" >
                <div class="border rounded py-2 container-fluid">
                    <h4 class="text-left" >Pagamentos pendentes</h4>
                    <hr>

                    <grid
                        controllers='false' 
                        :titles='grid.titles'
                        :data='grid.content'
                        current-sort="id"
                        @clicked="onClickEvent"
                    />
                </div>
            </div>
            <div class="col-md-5 col-12 py-2" >
                <div class="border rounded py-2 container-fluid" >
                    <h4 class="text-left" >Informações da duplicata</h4>
                    <hr>

                    <form>
                        <div class="form-row">
                            <div class="col-8">
                                <div class="form-group">
                                    <label >Identificador</label>
                                    <input type="text" v-model="movimentInfo.id" class="form-control" disabled placeholder="Identificador" >
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label >Documento</label>
                                    <input type="text" v-model="movimentInfo.doc" class="form-control" disabled placeholder="Documento" >
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col">
                                <div class="form-group">
                                    <label >Mora ao dia</label>
                                    <input type="text" v-model="movimentInfo.mora" class="form-control" disabled placeholder="Mora ao dia" >
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label >Juros/Desconto</label>
                                    <input type="text" v-model="movimentInfo.juros" class="form-control" disabled placeholder="Juros / Descontos" >
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col">
                                <div class="form-group">
                                    <label >Pago capital</label>
                                    <input type="text" v-model="movimentInfo.pagoCap" class="form-control" disabled placeholder="Pago capital" >
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label >Total pago</label>
                                    <input type="text" v-model="movimentInfo.pagoTot" class="form-control" disabled placeholder="Total pago" >
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label >Data do pagamento</label>
                            <input type="text" v-model="movimentInfo.dataPag" class="form-control" disabled placeholder="Data do pagamento" >
                        </div>
                        <div class="form-group">
                            <label >Conta financeira</label>
                            <input type="text" v-model="movimentInfo.conta" class="form-control" disabled placeholder="Conta financeira" >
                        </div>

                        <div class="form-row">
                            <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                <div class="form-group">
                                    <label >Pagamento no</label>
                                    <input type="text" v-model="movimentInfo.pagamento" class="form-control" disabled placeholder="Pagamento no caixa" >
                                </div>
                            </div>
                            <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                <div class="form-group">
                                    <label >Forma de pagamento</label>
                                    <input type="text" v-model="movimentInfo.forma" class="form-control" disabled placeholder="Forma de pagamento" >
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import grid from '@/components/grid.vue'
    export default {
        name: 'toPayView',
        components: {
            grid
        },
        data(){
            return {
                grid: {
                    titles  : [
                        'id', 
                        'Fornecedor',
                        'Documento',
                        'Parcela', 
                        'Vencimento', 
                        'Dias atraso',
                        'Conta',
                        'Data', 
                        'Valor', 
                        'Valor pago', 
                        'Mora',
                        'Saldo',
                        'Juros'
                    ],
                    content : []
                },

                movimentInfo: {
                    id: 0,
                    doc: 0,
                    mora: 1,
                    juros: 1,
                    pagoCap: 0.00,
                    pagoTot: 0.00,
                    dataPag: '10/04/1997',
                    conta: 'Conta',
                    pagamento: 'Caixa',
                    forma: 'Cartão'
                }
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        methods: {
            getData: function(){
                fetch(server + 'grides/contas/pagar', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    }),
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        this.grid.content = responseJSON.response
                    })
                    .catch(error => {
                        console.error('Error exception', '=>', error.code)
                    })
            },

            onClickEvent: function(value){
                fetch(server + 'grides/contas/pagar/' + value.id, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    }),
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        let data = responseJSON.response[0]

                        this.movimentInfo.id        = data.id
                        this.movimentInfo.doc       = data.documento
                        this.movimentInfo.mora      = data.mora
                        this.movimentInfo.juros     = data.juros
                        this.movimentInfo.pagoCap   = data.saldo
                        this.movimentInfo.pagoTot   = data.pago
                        this.movimentInfo.dataPag   = data.data
                        this.movimentInfo.conta     = data.conta
                    })
                    .catch(error => {
                        console.error('Error exception', '=>', error.code)
                    })
            }
        },
        mounted(){
            this.getData()
        }
    }
</script>